// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
        numberFilterTree: 2
    },
};

var bcSfFilterTemplate = {
    'gridBorderClass': 'grid-item-border',
    'onSaleClass': 'on-sale',
    'soldOutClass': 'sold-out',

    'quickViewHtml': '<a class="quickview-button" href="javascript:void(0)" id="{{itemHandle}}" title="' + bcSfFilterConfig.label.quick_view + '"><span>' + bcSfFilterConfig.label.quick_view + '</span></a>',
    'reviewHtml': '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>',

    // Grid Template
    'productGridItemHtml': '<div class="grid-item col-xs-6 ' + bcSfFilterConfig.custom.grid_item_width + ' {{itemGridBorderClass}} {{itemCropImageClass}} abc">' +
                                '<div class="inner product-item {{itemSoldOutClass}} {{itemSaleClass}} wow fadeIn" data-wow-delay="{{delayTime}}ms" id="product-{{itemId}}">' +
                                    '<div class="inner-top">' +
                                        '<div class="product-top">' +
                                            '<div class="product-image {{itemFlipImageLabel}}" data-collections-related="{{itemCollectionRelated}}">' +
                                                '<a href="{{itemUrl}}" class="product-grid-image" data-collections-related="{{itemCollectionRelated}}">' +
                                                    '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}" class="images-one">' +
                                                    '{{itemImageTwo}}' +
                                                '</a>' +
                                            '</div>' +
                                            '{{itemLabels}}' +
                                            '<div class="product-des abs-center">' +
                                                '{{itemWishlist}}' +
                                                '{{itemAddToCart}}' +
                                            '</div>' +
                                            '<div class="product-des abs-bottom">' +
                                                '{{itemQuickView}}' +
                                            '</div>' +
                                        '</div>' +
                                        // Product Bottom
                                        '<div class="product-bottom">' +
                                            '{{itemVendor}}' +
                                            '<a class="product-title" href="{{itemUrl}}">{{itemTitle}}</a>' +
                                            '{{itemReview}}' +
                                            '<div class="price-box">{{itemPrice}}</div>' +
                                            '<a href="{{itemUrl}}" style="text-decoration: none;"></a>' +
                                            '{{itemColorSwatches}}' +
                                            //'{{itemLooxRatting}}' +
                                        '</div>' +
                                        // Product Detail
                                        '<div class="product-details">' +
                                            '{{itemVendor}}' +
                                            '<a class="product-title" href="{{itemUrl}}">{{itemTitle}}</a>' +
                                            '{{itemReview}}' +
                                            '<div class="short-description">{{itemDescription}}</div>' +
                                            '<div class="price-box">{{itemPrice}}</div>' +
                                            '{{itemColorSwatches}}' +
                                            '<div class="action">{{itemAddToCart}}</div>' +
                                             '{{itemWishlist}}' +
                                        '</div>' +
                                        // End Product Detail
                                    '</div>' +
                                '</div>' +
                            '</div>',

    // List Template
    'productListItemHtml':  '<div class="grid-item product-item {{itemSoldOutClass}} {{itemSaleClass}} wow fadeIn" data-wow-delay="{{delayTime}}ms" id="product-{{itemId}}">' +
                                '<div class="product-image">' +
                                    '<a href="{{itemUrl}}" class="product-list-thumb product-grid-image">' +
                                        '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                    '</a>' +
                                    '{{itemLabels}}' +
                                '</div>' +

                                '<div class="product-details">' +
                                    '<a class="product-title" href="{{itemUrl}}">{{itemTitle}}</a>' +
                                    '{{itemVendor}}' +
                                    '{{itemReview}}' +
                                    '<div class="short-description">{{itemDescription}}</div>' +
                                    '{{itemColorSwatches}}' +
                                    '<div class="price-box">{{itemPrice}}</div>' +
                                    '<div class="action">{{itemAddToCart}}</div>' +
                                    '{{itemWishlist}}' +
                                '</div>' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<li class="text"><i class="fa fa-angle-left" aria-hidden="true"></i><a href="{{itemUrl}}">Previous</a></li>',
    'previousDisabledHtml': '<li class="disabled"><i class="fa fa-angle-left" aria-hidden="true"></i><span>Previous</span></li>',
    'nextActiveHtml': '<li class="text"><a href="{{itemUrl}}">Next</a><i class="fa fa-angle-right" aria-hidden="true"></i></li>',
    'nextDisabledHtml': '<li class="disabled"><span>Next</span><i class="fa fa-angle-right" aria-hidden="true"></i></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="active"><span>{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
    // Sorting Template
    'sortingHtml': '<span class="bc-sf-filter-sorting-label">' + bcSfFilterConfig.label.sorting + '</span><label><span><span>' + bcSfFilterConfig.label.sorting + '</span></span></label><ul class="bc-sf-filter-filter-dropdown">{{sortingItems}}</ul>',
    
    
};

BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add class
    itemHtml = bcSfFilterConfig.custom.product_image_border ? itemHtml.replace(/{{itemGridBorderClass}}/g, bcSfFilterTemplate.gridBorderClass) : itemHtml.replace(/{{itemGridBorderClass}}/g, '');
    itemHtml = bcSfFilterConfig.custom.product_image_crop ? itemHtml.replace(/{{itemCropImageClass}}/g, 'crop_image') : itemHtml.replace(/{{itemCropImageClass}}/g, 'no_crop_image');
    itemHtml = soldOut ? itemHtml.replace(/{{itemSoldOutClass}}/g, bcSfFilterTemplate.soldOutClass) : itemHtml.replace(/{{itemSoldOutClass}}/g, '');
    itemHtml = onSale ? itemHtml.replace(/{{itemSaleClass}}/g, bcSfFilterTemplate.onSaleClass) : itemHtml.replace(/{{itemSaleClass}}/g, '');
    itemHtml = itemHtml.replace(/{{delayTime}}/g, bcSfFilterConfig.custom.time_lazy_load * index);

    // Add Thumbnail
//     var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '1024x1024') : bcSfFilterConfig.general.no_image_url;
//     var itemFlipImageUrl = images.length > 1 ? this.optimizeImage(images[1]['src'], '1024x1024') : itemThumbUrl;
  
    	// Add Thumbnail
      var itemThumbUrl = images.length > 0 ? images[0]['src'] : bcSfFilterConfig.general.no_image_url;
      if (this.queryParams.hasOwnProperty('pf_opt_color')) {
          //var selectedColor = this.queryParams.pf_opt_color[0].toLowerCase();
          var selectedColors = this.queryParams.pf_opt_color;
          for (var k = 0; k < selectedColors.length; k++) {
              var selectedColor = selectedColors[k].toLowerCase();
              for (var i = 0; i < data.variants.length; i++) {
                  var variant = data['variants'][i];
                  if (variant.hasOwnProperty('merged_options') && variant['merged_options'].length > 0) {
                      for (var j = 0; j < variant['merged_options'].length; j++) {
                          var mergeValue = variant['merged_options'][j].toLowerCase();
                          if (mergeValue.indexOf(selectedColor) > -1) {
                              var itemThumbUrl = variant['image'];
                              break;
                          }
                      }
                  }
              }
          }
      }
      itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
  
    var itemFlipImageLabel = images.length > 1 ? 'image-swap ' : '';
    itemHtml = itemHtml.replace(/{{itemFlipImageLabel}}/g, itemFlipImageLabel);
  
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
    itemHtml = itemHtml.replace(/{{itemFlipImageUrl}}/g, itemFlipImageUrl);

    // Add Label
    var itemLabelsHtml = '';
    if (onSale || soldOut) {
        itemLabelsHtml += '<div class="product-label">';
        if (onSale) {
            itemLabelsHtml += '<strong class="label sale-label">' + bcSfFilterConfig.label.sale + '</strong>';
        }
        if (soldOut) {
            itemLabelsHtml += '<strong class="label sold-out-label">' + bcSfFilterConfig.label.sold_out + '</strong>';
        }
        itemLabelsHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
        itemPriceHtml += '<p class="sale">';
//         itemPriceHtml += '<span class="old-price"> ' + this.formatMoney(data.compare_at_price_min) +'</span>';
        itemPriceHtml += '<span class="special-price">';
        if (priceVaries) {
            itemPriceHtml += '<em>' + bcSfFilterConfig.label.from_price + ' </em>';
        }
        itemPriceHtml += this.formatMoney(data.price_min);
        itemPriceHtml += '</span>';
        itemPriceHtml += '</span></p>';
    } else {
        itemPriceHtml += '<p class="regular-product"><span>';
        if (priceVaries) {
            itemPriceHtml += '<em>' + bcSfFilterConfig.label.from_price + ' </em>'
        }
        itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
        itemPriceHtml += '</span></p>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Vendor
    var itemVendorHtml = '';
    if (bcSfFilterConfig.custom.show_vendor) {
        itemVendorHtml = '<div class="product-vendor">' + data.vendor + '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add to cart
    var itemAddToCartHtml = '';
    if (bcSfFilterConfig.custom.display_button) {
        var itemAddToCartHtml = '<div class="action"><form action="/cart/add" method="post" class="variants" id="product-actions-{{itemId}}" enctype="multipart/form-data" style="padding:0px;">';
        if (soldOut) {
            itemAddToCartHtml += '<input class="btn add-to-cart-btn" type="submit" value="' + bcSfFilterConfig.label.unavailable + '" disabled="disabled"/>';
        } else {
            if (data.variants.length > 1) {
                itemAddToCartHtml += '<input class="btn" type="button" onclick="window.location.href=\'{{itemUrl}}\'" value="' + bcSfFilterConfig.label.select_options + '" />';
            } else {
                itemAddToCartHtml += '<input type="hidden" name="id" value="' + firstVariant.id + '" />';
                itemAddToCartHtml += '<button data-btn-addtocart="" class="btn add-to-cart-btn" type="submit" data-translate="products.product.add_to_cart">'+bcSfFilterConfig.label.add_to_cart+'</button>';
            }
        }
        itemAddToCartHtml += '</form></div>';
    }
    itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, itemAddToCartHtml);
  
    //collection related
    var relatedCollection = window.location.pathname + '?view=related';
    itemHtml = itemHtml.replace(/{{itemCollectionRelated}}/g, relatedCollection);

    // Add Quick view
    var itemQuickViewHtml = '';
    if (bcSfFilterConfig.custom.enable_quick_view) {
        itemQuickViewHtml = bcSfFilterTemplate.quickViewHtml;
    }
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

    // Add Review
    var itemReviewHtml = bcSfFilterConfig.custom.display_product_reviews ? bcSfFilterTemplate.reviewHtml : '';
    itemHtml = itemHtml.replace(/{{itemReview}}/g, itemReviewHtml);

    // Add Color Swatches
    itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));

    // Add Wishlist
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, buildWishlist(data));

    // Add Ratting
    var itemLooxRattingHtml = '';
    
    itemLooxRattingHtml = '<div class="loox-rating" style="margin-top:8px; font-size:14px; text-align:center" data-id="{{itemId}}" data-rating="' + this.getProductMetafield(data, 'loox', 'avg_rating') +'" data-raters="' + this.getProductMetafield(data, 'loox', 'num_reviews') +'"></div>';
    
    itemHtml = itemHtml.replace(/{{itemLooxRatting}}/g, itemLooxRattingHtml);

    // Image Swap
    var itemImageTwoHtml = '';
    var itemFlipImageUrl = images.length > 1 ? this.optimizeImage(images[1]['src'], '1024x1024') : itemThumbUrl;
    if (images.length > 1) {
        itemImageTwoHtml = '<span class="images-two"><img src="' + itemFlipImageUrl + '" alt="{{itemTitle}}" /></span>';
    }
    itemHtml = itemHtml.replace(/{{itemImageTwo}}/g, itemImageTwoHtml);

    // Add Description
    var itemDescription = '';
    //console.log("data.body_html" + data.body_html);
    //if (data.body_html.indexOf('[countdown]') !== -1) {
        itemDescription = jQ('<p>' + data.body_html + '</p>').text();
        var tempArr = itemDescription.split('[/countdown]');
        itemDescription = tempArr.pop();
        itemDescription = this.truncateByWord(itemDescription, 50);
    //}
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
  



    

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
}

BCSfFilter.prototype.buildProductListItem = function(data, index, totalProduct) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productListItemHtml;

    // Add class
    itemHtml = soldOut ? itemHtml.replace(/{{itemSoldOutClass}}/g, bcSfFilterTemplate.soldOutClass) : itemHtml.replace(/{{itemSoldOutClass}}/g, '');
    itemHtml = onSale ? itemHtml.replace(/{{itemSaleClass}}/g, bcSfFilterTemplate.onSaleClass) : itemHtml.replace(/{{itemSaleClass}}/g, '');
    itemHtml = itemHtml.replace(/{{delayTime}}/g, bcSfFilterConfig.custom.time_lazy_load * index);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Label
    var itemLabelsHtml = '';
    if (onSale || soldOut) {
        itemLabelsHtml += '<div class="product-label">';
        if (onSale) {
            itemLabelsHtml += '<strong class="label">' + bcSfFilterConfig.label.sale + '</strong>';
        }
        if (soldOut) {
            itemLabelsHtml += '<strong class="sold-out-label">' + bcSfFilterConfig.label.sold_out + '</strong>';
        }
        itemLabelsHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
        itemPriceHtml += '<p class="sale">';
        itemPriceHtml += '<span class="old-price money"> ' + this.formatMoney(data.compare_at_price_min) +'</span>';
        if (priceVaries) {
            itemPriceHtml += '<span class="special-price"><em>' + bcSfFilterConfig.label.from_price + ' </em>';
        } else {
            itemPriceHtml += '<span class="special-price">';
        }
        itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
        itemPriceHtml += '</span></p>';
    } else {
        itemPriceHtml += '<p class="regular-product">';
        if (priceVaries) {
            itemPriceHtml += '<span class="money"><em>' + bcSfFilterConfig.label.from_price + ' </em>' + this.formatMoney(data.price_min) + '</span>';
        } else {
            itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
        }
        itemPriceHtml += '</p>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Vendor
    var itemVendorHtml = '';
    if (bcSfFilterConfig.custom.show_vendor) {
        itemVendorHtml = '<div class="product-vendor">' + data.vendor + '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add to cart
    var itemAddToCartHtml = '<form action="/cart/add" method="post" class="variants" id="product-actions-{{itemId}}" enctype="multipart/form-data" style="padding:0px;">';
    if (soldOut) {
        itemAddToCartHtml += '<input class="btn add-to-cart-btn" type="submit" value="' + bcSfFilterConfig.label.unavailable + '" disabled="disabled"/>';
    } else {
        if (data.variants.length > 1) {
            itemAddToCartHtml += '<input class="btn" type="button" onclick="window.location.href=\'{{itemUrl}}\'" value="' + bcSfFilterConfig.label.select_options + '" />';
        } else {
            itemAddToCartHtml += '<input type="hidden" name="id" value="' + firstVariant.id + '" />';
            itemAddToCartHtml += '<input class="btn add-to-cart-btn" type="submit" value="' + bcSfFilterConfig.label.add_to_cart + '" />';
        }
    }
    itemAddToCartHtml += '</form>';
    itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, itemAddToCartHtml);

    // Add Quick view
    var itemQuickViewHtml = '';
    if (bcSfFilterConfig.custom.enable_quick_view) {
        itemQuickViewHtml = bcSfFilterTemplate.quickViewHtml;
    }
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

    // Add Review
    var itemReviewHtml = bcSfFilterConfig.custom.display_product_reviews ? bcSfFilterTemplate.reviewHtml : '';
    itemHtml = itemHtml.replace(/{{itemReview}}/g, itemReviewHtml);

    // Add Color Swatches
    itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));

    // Add Wishlist
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, buildWishlist(data));

    // Add Description
    var itemDescription = '';
    if (data.body_html.indexOf('[countdown]') !== -1) {
        itemDescription = jQ('<p>' + data.body_html + '</p>').text();
        var tempArr = itemDescription.split('[/countdown]');
        itemDescription = tempArr.pop();
        itemDescription = this.truncateByWord(itemDescription, 50);
    }
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
}

// Build Wishlist
function buildWishlist(data) {
  // Add Wishlist
  var wishlistHtml = '';
  if (bcSfFilterConfig.custom.enable_wishlist) {
    var value = (data.id).toString();
    var productId = (data.id).toString();
    for (var k in bcSfFilterConfig.customer.tags) {
      
      var tagID = bcSfFilterConfig['customer']['tags'][k];
      if (tagID.indexOf(productId) > -1) {
        value = 'x' + tagID;
      }
      if (value.length == 0) value = productId;
    }
    if (value.length > 0) {
      var check = ((value.length - productId.length) / 2).toString();
      check = check.split('.');
      var display = check.length > 1 && check[1].indexOf('5') > - 1 ? false : true;
    }

    wishlistHtml += '<a class="wishlist" data-icon-wishlist href="#" data-product-handle="' + data.handle + '"title="' + bcSfFilterConfig.label. wishlist_note + '" data-id="' + data.id + '">' +
      '<i class="fa fa-heart" aria-hidden="true"></i>' +
      '<span class="wishlist-text text-hover">' + bcSfFilterConfig.label.add_to_wishlist + '</span>' +
      '</a>';

  }
  return wishlistHtml;
}

// Build Color Swatches
function buildColorSwatches(data) {
  var colorSwatchesHtml = '';
  if (bcSfFilterConfig.custom.display_item_swatch) {
    colorSwatchesHtml += '<ul class="item-swatch">';
    for (var index in data.options) {
      var option = data['options'][index].toLowerCase();
      if (option == 'color') {
        var colorlist = '';
        var color = '';
        var totalVariants = 0;
        for (var k in data.variants) {
          var variant = data['variants'][k];
          color = variant['options'][index];
          if (colorlist.indexOf(color) == -1) {
            if(totalVariants < 4) {
              var text = bcsffilter.slugify(color);
              var border = text == 'white' ? 'border: 1px solid #cbcbcb;' : '';
              var backgroundImage = bcsffilter.optimizeImage(variant.image, '24x');
              var dataImg = "data-img='" + bcsffilter.optimizeImage(variant.image) + "'";
              var dataColor = '#fff';
              if (bcSfFilterConfig.custom.color_swatch_style === 'normal') { 
                var _file = variant.option_color.toLowerCase().replace(/ /g, '-');
                var dataColors = variant.option_color.toLowerCase().split(' ');
                var i = dataColors.length - 1;
                if(dataColors[i] !== '' && dataColors[i] !== 'colors') {
                    dataColor = dataColors[i];
                }
                
                backgroundImage = bcSfFilterConfig.general.file_url.replace('?', _file + '.png?v=')
              }

              colorSwatchesHtml += '<li>';
              colorSwatchesHtml += '<div class="tooltip">'+color+'</div>';
              colorSwatchesHtml += '<label style="' + border + 'background-image: url(' + backgroundImage + '); background-color: '+dataColor+';"' + dataImg + '></label>';

              // colorSwatchesHtml += '<label style="' + border + 'background-image: url(' + bcsffilter.optimizeImage(variant.image, '24x') + ');"' + if (variant.image !== null){ + 'data-img="' + bcsffilter.optimizeImage(variant.image) + '"' + } '></label>';
              colorSwatchesHtml += '</li>';
              
            }
            var templist = colorlist + color + ' ';
            colorlist = templist;
            
            totalVariants++;

          }

        }
        
        console.log(totalVariants);

        if (totalVariants > 4) {
          colorSwatchesHtml += '<li class="item-swatch-more">';
          colorSwatchesHtml += '<a href="{{itemUrl}}" title="More Color">+'+(totalVariants-4)+'</a>';
          colorSwatchesHtml += '</li>';
          totalVariants = 0;
        }
      }
    }
    colorSwatchesHtml += '</ul>';
  }
  return colorSwatchesHtml;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');
    var sortingArr = this.getSortingList();
    if (sortingArr) {
      var url = new URL(window.location.href);
      var paramSort = url.searchParams.get("sort");
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        activeClass = '';
        if(paramSort == k) {
          activeClass = 'active';
        }
        sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass+ '">' + sortingArr[k] + '</a></li>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ('.bc-sf-filter-custom-sorting').html(html);
      if(jQ('.bc-sf-filter-custom-sorting').hasClass("bc-sf-filter-sort-active")) {
        jQ('.bc-sf-filter-custom-sorting').toggleClass('bc-sf-filter-sort-active');
      }

      jQ(".bc-sf-filter-custom-sorting > label").click(function(){
        if (!jQ('.bc-sf-filter-filter-dropdown').is(':animated')) {
          jQ('.bc-sf-filter-filter-dropdown').toggle().parent().toggleClass('bc-sf-filter-sort-active');
          jQ('#bc-sf-filter-tree').hide();
        }
      });
    }
  }
};

// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function() {
  var _this = this;
  jQ('.bc-sf-filter-filter-dropdown a').click(function(e){
    e.preventDefault();
    onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('sort'));
  })
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
    var itemHtml = '<label>' + bcSfFilterConfig.label.view_as + '</label>';
    itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="' + bcSfFilterConfig.label.grid_view + '" class="grid bc-sf-filter-display-grid"><span>' + bcSfFilterConfig.label.grid_view  + '</span></a> ';
    itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="' + bcSfFilterConfig.label.list_view  + '" class="list bc-sf-filter-display-list"><span>' + bcSfFilterConfig.label.list_view  + '</span></a>';
    jQ(this.selector.topDisplayType).html(itemHtml);

    // Active current display type
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
    if (this.queryParams.display == 'list') {
        jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
    } else if (this.queryParams.display == 'grid') {
        jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
    }
};

BCSfFilter.prototype.buildExtrasProductList = function(data) {
    //$('#bc-sf-filter-products').removeClass();
    // if (this.queryParams.display == 'list') {
    //     $('#bc-sf-filter-products').addClass('product-list products-list');
    // } else {
    //     $('#bc-sf-filter-products').addClass('product-collection products-grid row');
    // }
  	var collectionTitle = jQ('.page-header h1 span').html();
  	var metaTitle = jQ('title').attr('title');
  	if (typeof collectionTitle != 'undefined') {
      if(typeof bcsffilter.queryParams.pf_opt_color !== "undefined"){
        bcsffilter.queryParams.pf_opt_color.map(function(color) {
            collectionTitle = collectionTitle + ' - ' + color;
            metaTitle = metaTitle + ' - ' + color;
        });
      } else {
          collectionTitle = collectionTitle.indexOf('-') !== -1 ? collectionTitle.substring(0, collectionTitle.indexOf('-')) : collectionTitle;
          metaTitle = metaTitle.indexOf('-') !== -1 ? metaTitle.substring(0, metaTitle.indexOf('-')) : metaTitle;
      }
      jQ('title').text(metaTitle + ' | DesignerHardware.com');
      jQ('.page-header h1 span').text(collectionTitle);
    }
};

// Build Additional Elements
BCSfFilter.prototype.buildAdditionalElements = function(data) {
 
      bcElla.initAddToCart();
      bcElla.initGroupedAddToCart();
      bcElla.changeQuantityAddToCart();
      bcElla.initStickyAddToCart();

      bcElla.initQuickView();

      bcElla.initColorSwatchGrid();

    if (jQ('.sidebar').length > 0){
        jQ('body').addClass('bc-has-sidebar');
    }

    // For Sort By 
  var url_string = document.URL
  var url = new URL(url_string);
  var labelSort = url.searchParams.get("sort");

  if(labelSort == null) {
    labelSort = this.queryParams.sort;
    
        switch (labelSort) {
      case 'best-selling': 
        labelSort = bcSfFilterConfig.label['sorting_best_selling'];
        break;
      case 'manual': 
        labelSort = bcSfFilterConfig.label['sorting_featured'];
        break;
      case 'price-ascending': 
        labelSort = bcSfFilterConfig.label['sorting_price_ascending'];
        break;
      case 'price-descending': 
        labelSort = bcSfFilterConfig.label['sorting_price_descending'];
        break;
      case 'title-ascending': 
        labelSort = bcSfFilterConfig.label['sorting_title_ascending'];
        break;
      case 'title-descending': 
        labelSort = bcSfFilterConfig.label['sorting_title_descending'];
        break;
      case 'created-ascending':
        labelSort = bcSfFilterConfig.label['sorting_date_ascending'];
        break;
      case 'created-descending':
        labelSort = bcSfFilterConfig.label['sorting_date_descending'];
        break;
    }
  } else {
    // labelSort = bcSfFilterConfig.label['sorting_' + labelSort.replace('-', '_')]
    switch (labelSort) {
      case 'best-selling': 
        labelSort = bcSfFilterConfig.label['sorting_best_selling'];
        break;
      case 'manual': 
        labelSort = bcSfFilterConfig.label['sorting_featured'];
        break;
      case 'price-ascending': 
        labelSort = bcSfFilterConfig.label['sorting_price_ascending'];
        break;
      case 'price-descending': 
        labelSort = bcSfFilterConfig.label['sorting_price_descending'];
        break;
      case 'title-ascending': 
        labelSort = bcSfFilterConfig.label['sorting_title_ascending'];
        break;
      case 'title-descending': 
        labelSort = bcSfFilterConfig.label['sorting_title_descending'];
        break;
      case 'created-ascending':
        labelSort = bcSfFilterConfig.label['sorting_date_ascending'];
        break;
      case 'created-descending':
        labelSort = bcSfFilterConfig.label['sorting_date_descending'];
        break;
    }
  }
  $('.bc-sf-filter-custom-sorting label span span').text(labelSort);
  
  jQ(this.getSelector('filterTreeMobileButton')).click(function(){
    jQ('#bc-sf-filter-top-sorting-mobile .bc-sf-filter-filter-dropdown').hide();
  })
  
  // End - For Sort By 
  // 
};

// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

BCSfFilter.prototype.prepareProductData = function(data) { var countData = data.length; for (var k = 0; k < countData; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } } data[k]['url'] = '/products/' + data[k].handle; var optionsArr = []; var countOptionsWithValues = data[k]['options_with_values'].length; for (var i = 0; i < countOptionsWithValues; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) } data[k]['options'] = optionsArr; if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) { var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim(); function updateMultiCurrencyPrice(oldPrice, newPrice) { if (typeof newPrice != 'undefined') { return newPrice; } return oldPrice; } data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]); data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]); data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]); data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]); } data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; var firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0] } else { var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } } data[k]['selected_or_first_available_variant'] = firstVariant; var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]['variants'][i]; var variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { var countVariantOptions = variantOptions.length; for (var j = 0; j < countVariantOptions; j++) { var temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]['variants'][i]['options'] = variantOptionArr } data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 } data[k]['description'] = data[k]['content'] = data[k]['body_html']; } return data };



// BCSfFilter.prototype.buildFilterSorting = function() {
//   if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
//     jQ(this.selector.topSorting).html('');

//     var sortingArr = this.getSortingList();
//     if (sortingArr) {
//       // Build content
//       var sortingItemsHtml = '';
//       for (var k in sortingArr) {
//         sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
//       }
//       var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
//       jQ(this.selector.topSorting).html(html);

//       // Set current value
//       jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
//     }
//   }
// };

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
